import { Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { IDialogData } from "../../viewer-components/interfaces/i-dialog-data";

export abstract class MultiExportGeotiffDialog {
  zipExport: boolean = true;

  protected constructor(
    private dialogRef: MatDialogRef<MultiExportGeotiffDialog>,
    @Inject(MAT_DIALOG_DATA) protected data: IDialogData,
  ) {}

  multiExportGeoTIFF() {
    this.dialogRef.close({
      zipFile: this.zipExport,
    });
  }
}
